import AccountInvoiceBalanceList from './account-invoice-balance.list';

export default {
  list: AccountInvoiceBalanceList,
  create: false,
  show: false,
  edit: false,
};
